<template>
  <div>

      <Banner></Banner>

      <BrandsLogos></BrandsLogos>

      <About></About>

      <Boundless></Boundless>

      <WhyWe></WhyWe>

      <TypeDiv></TypeDiv>

      <ServicesType></ServicesType>

      <Portfolio></Portfolio>

      <Const></Const>
  </div>
</template>

<script>
import Banner from '../../components/MobileDevelopment/AndroidDevelopment/Banner.vue'
import Boundless from '../../components/MobileDevelopment/AndroidDevelopment/Boundless.vue'
import WhyWe from '../../components/MobileDevelopment/AndroidDevelopment/WhyWe.vue'
import ServicesType from '../../components/MobileDevelopment/IosDevelopment/ServicesType.vue'
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue'
import Portfolio from '../../components/Home/Portfolio.vue'
import About from '../../components/MobileDevelopment/AndroidDevelopment/About.vue'
import TypeDiv from '../../components/Home/TypeDiv.vue'
import Const from '../../components/AssetComponents/Const.vue'

export default {
    components:{
        Banner,
        BrandsLogos,
        About,
        TypeDiv,
        WhyWe,
        Portfolio,
        Const,
        Boundless,
        ServicesType
    }
}
</script>


<style>

</style>